var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80082 7.04198C7.80082 9.18965 6.0716 10.9308 3.93843 10.9308C1.80526 10.9308 0.0761719 9.19018 0.0761719 7.04198C0.0761719 4.89378 1.80539 3.15332 3.93843 3.15332C6.07146 3.15332 7.80082 4.8943 7.80082 7.04198Z",
    fill: "#8CC8BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0376 7.04194C12.0376 9.06371 11.1729 10.7025 10.1064 10.7025C9.03995 10.7025 8.17529 9.06318 8.17529 7.04194C8.17529 5.02069 9.03995 3.38135 10.1064 3.38135C11.1729 3.38135 12.0376 5.02069 12.0376 7.04194Z",
    fill: "#8CC8BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7708 7.04194C13.7708 8.85335 13.4666 10.3217 13.0916 10.3217C12.7165 10.3217 12.4124 8.85283 12.4124 7.04194C12.4124 5.23106 12.7165 3.76221 13.0917 3.76221C13.4669 3.76221 13.7708 5.23067 13.7708 7.04194Z",
    fill: "#8CC8BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.38f3e6dd3aaa5d45d89f6dd40363d7a6.svg";
export { ForwardRef as ReactComponent };